import { Center, Spinner } from '@chakra-ui/react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useGlobalAccess } from '../context/GlobalAccessContext';

interface ProtectedRouteProps {
  children: JSX.Element;
  requiredAccess?: 'aviation' | 'insight' | 'guacamole' | 'admin';
}

function ProtectedRoute({ children, requiredAccess }: ProtectedRouteProps) {
  const { user, isLoading } = useAuth();
  const { globalAviationAccess } = useGlobalAccess();
  const location = useLocation();

  console.log('ProtectedRoute:', {
    isLoading,
    user,
    currentPath: location.pathname,
    requiredAccess,
    globalAviationAccess
  });

  if (isLoading) {
    return (
      <Center h="100vh">
        <Spinner size="xl" />
      </Center>
    );
  }

  if (!user) {
    console.log('No user, redirecting to login');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check required access with optional chaining
  if (requiredAccess) {
    // Special handling for aviation access - check both individual and global access
    if (requiredAccess === 'aviation') {
      const hasAviationAccess = user?.access?.aviation || globalAviationAccess;
      if (!hasAviationAccess) {
        console.log('User lacks aviation access (both individual and global), redirecting to home');
        return <Navigate to="/" replace />;
      }
    } else {
      // For other access types, check only individual permissions
      if (!user?.access?.[requiredAccess]) {
        console.log(`User lacks ${requiredAccess} access, redirecting to home`);
        return <Navigate to="/" replace />;
      }
    }
  }

  return children;
}

export default ProtectedRoute;